export var Chat = (function () {
    function Chat(message, fromAuthor, system) {
        this.created = firebase.database['ServerValue']['TIMESTAMP'];
        this.message = message;
        this.fromAuthor = fromAuthor;
        this.system = system || null;
    }
    return Chat;
}());
